import {commitMutation, graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';

const mutation = graphql`
	mutation SupressProgramBudgetTypeTipMessageMutation($input: SupressProgramBudgetTypeTipMessageInput!) {
		supressProgramBudgetTypeTipMessage(input: $input) {
			clientMutationId
			person {
				id
				supressProgramBudgetTypeTipMessage
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
